// Google Analytics bootstrap - kept as a module so the strict CSP
// (script-src 'self' + googletagmanager) still applies; no inline scripts.
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

window.dataLayer = window.dataLayer || [];
function gtag(...args: unknown[]) {
  window.dataLayer.push(args);
}
gtag('js', new Date());
gtag('config', 'G-K42WE6C0RV');

export {};
